import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import EditAuthorPopup from './EditAuthorPopup';
import { COSYND_WORK_FOR_HIRE_URL } from '../../constants';
import {
  getRoleNames,
  splitName,
  populateContributions,
  getFullName,
  getSubWorkTypeNameById,
  getWorkTypeNameById,
} from '../../utils';
const DEFAULT_MUSIC_CONTRIBUTIONS = [
  'Sound Recording',
  'Musical Composition + Sound Recording',
];

class Authors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      editAuthor: null,
      authors: [],
    };
  }

  componentWillMount() {
    const { members, fields } = this.props;

    if (members) {
      if (fields && fields.authors && fields.authors.length === 0) {
        this.setInitialMigrateAuthors(members);
      } else {
        this.setState({ authors: fields.authors });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { fields, members } = nextProps;

    if (this.props.fields.authors !== fields.authors) {
      this.setState({ authors: fields.authors });
    }

    if (this.props.members !== members) {
      if (fields && fields.authors && fields.authors.length === 0) {
        this.setInitialMigrateAuthors(members);
      }
    }
  }

  setInitialMigrateAuthors(members) {
    const { fields } = this.props;
    let authors = fields.authors || [];
    let works = fields.works || [];
    if (
      fields &&
      authors &&
      authors.length === 0 &&
      works &&
      works.length > 0
    ) {
      this.props.assignAttribute('authors', this.migrateAuthors(members));
    }
  }

  migrateAuthors(members) {
    const { roles, fields, workTypes, subWorkTypes } = this.props;

    return members.map((member, i) => {
      const names = splitName(member.user_info.name);
      const roleNames = getRoleNames(member.role_ids, roles);

      // const workforhire = roleNames.indexOf('Contributor (Work for Hire)') !== -1;

      let contributions = populateContributions(roleNames);

      const typeName = getWorkTypeNameById(fields.type, workTypes);
      const subTypeName = getSubWorkTypeNameById(fields.subType, subWorkTypes);
      // Set default contributions
      if (typeName === 'Music') {
        // Set "Sound Recording" as default contributions if user selected "Music" or "Music + Sound Recording" from Creg type.
        contributions = [];
        if (DEFAULT_MUSIC_CONTRIBUTIONS.includes(subTypeName)) {
          contributions = ['Sound Recording'];
        }
      }

      return {
        id: i + 1,
        firstName: names.firstName,
        middleName: '',
        lastName: names.lastName,
        // organization: '',
        citizenship: '',
        domicile: '',
        anonymous: false,
        pseudonym: '',
        workforhire: -1,
        contributions,
        address: member.user_info.address,
        city: member.user_info.city,
        state: member.user_info.state,
        zip: member.user_info.postal,
        country: member.user_info.country,
      };
    });
  }

  openEditModal(e, author) {
    e.preventDefault();
    this.setState({
      openModal: true,
      editAuthor: author,
    });
  }

  openNewModal(e) {
    e.preventDefault();
    this.setState({
      openModal: true,
      editAuthor: null,
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      editAuthor: null,
    });
  }

  updateAuthor(authorProps) {
    const { fields } = this.props;
    const authors = fields.authors || [];

    if (this.state.editAuthor) {
      const index = R.findIndex(R.propEq('id', this.state.editAuthor.id))(
        authors
      );
      if (index !== -1) {
        authors[index] = { ...authorProps, id: this.state.editAuthor.id };
      }
    } else {
      const lastIndex = authors.length ? authors[authors.length - 1].id : 0;
      authors.push({ ...authorProps, id: lastIndex + 1 });
    }

    this.props.assignAttribute('authors', [...authors]);
  }

  deleteAuthor(e, author) {
    const { fields } = this.props;
    const authors = fields.authors || [];
    const authorName = getFullName(author);

    if (
      confirm(`Are you sure you want to delete the author "${authorName}"?`)
    ) {
      const index = R.findIndex(R.propEq('id', author.id))(authors);
      if (index !== -1) {
        authors.splice(index, 1);
        this.props.assignAttribute('authors', [...authors]);
      }
    }
  }

  handleNext() {
    const { fields, subWorkTypes } = this.props;
    const authors = fields.authors || [];

    this.props.hideAlert();

    if (authors.length) {
      const validates = R.filter(
        ({
          firstName,
          lastName,
          organization,
          citizenship,
          domicile,
          contributions,
        }) =>
          (organization ? !organization : !firstName) ||
          !(citizenship || domicile) ||
          !contributions.length
      )(authors);

      if (validates.length) {
        this.props.alert('error', 'Please check the required fields.');
      } else {
        const contributionValidates = R.filter(
          ({ contributions }) => !contributions || contributions.length === 1
        )(authors);

        if (contributionValidates.length) {
          // Show alert unless user have chosen over 2 contribution about 'Musical Composition + Sound Recording'
          const subTypeName = getSubWorkTypeNameById(
            fields.subType,
            subWorkTypes
          );
          if (subTypeName === DEFAULT_MUSIC_CONTRIBUTIONS[1]) {
            this.props.alert(
              'error',
              'Sorry, in order to register both the sound recording(s) and composition(s) together, each author must have contributed to the sound recording and the composition (music+lyrics). Please select either music or lyrics for each contributor to move forward or go back and register the sound recording(s) and compositions(s) separately.'
            );
            return;
          }
        }

        this.props.assignAttribute('claimants', [...authors]);
        this.props.router.push('/copyright-reg/claimants');
      }
    } else {
      this.props.alert('error', 'Please add an author at least.');
    }
  }

  renderAuthors() {
    const { authors } = this.state;

    return (
      authors && (
        <div className="table-container">
          <Table>
            <thead>
              <tr>
                <th>
                  <span className="text-red">*</span>First Name
                </th>
                <th>Middle Name</th>
                <th>
                  <span className="text-red">*</span>Last Name
                </th>
                <th>Organization</th>
                <th>
                  <span className="text-red">*</span>Citizenship or
                  <br />
                  Domicile
                </th>
                {/* <th>Anonymous</th> */}
                <th>Pseudonym</th>
                <th>Commissioned Work</th>
                <th>
                  <span className="text-red">*</span>Contribution
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {authors.map((author, i) => (
                <tr key={i}>
                  <td>{author.firstName}</td>
                  <td>{author.middleName}</td>
                  <td>{author.lastName}</td>
                  <td className="text-center">{author.organization}</td>
                  <td>{author.citizenship || author.domicile}</td>
                  {/* <td className="text-center">{author.anonymous ? 'Y' : ''}</td> */}
                  <td>{author.pseudonym}</td>
                  <td className="text-center">
                    {author.workforhire === -1 || author.workforhire === '-1'
                      ? ''
                      : author.workforhire === 'true'
                      ? 'Y'
                      : 'N'}
                  </td>
                  <td>{author.contributions.join(', ')}</td>
                  <td>
                    <span className="actions">
                      <a onClick={(e) => this.openEditModal(e, author)}>
                        <FontAwesome name="pencil" />
                      </a>
                      <a onClick={(e) => this.deleteAuthor(e, author)}>
                        <FontAwesome name="trash" />
                      </a>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )
    );
  }

  render() {
    const { editAuthor } = this.state;

    return (
      <div className="select-work">
        <Heading text="Which authors should be listed?" />
        <div className="content">
          <p>
            <b>What is an Author?</b>
          </p>
          <p>
            An author is the person who created the work(s) or a person or
            company that hired others to complete the work(s) on their behalf.{' '}
            If someone was paid on a{' '}
            <a href={COSYND_WORK_FOR_HIRE_URL} target="_blank">
              "work for hire"
            </a>{' '}
            basis to complete the work(s), do not include them as an author.{' '}
            Instead, add the company/person that paid to have the work(s)
            completed as an author.
          </p>

          <p>
            <b>Author Information:</b>
            <br />
          </p>
          <p>
            We may have transferred any available information about the work(s)
            from your Cosynd profile to the section below. Please verify this
            data and add any additional required information that may be
            missing.
          </p>
          {this.renderAuthors()}

          <div className="add-title-button text-right">
            <div className="add-view" onClick={(e) => this.openNewModal(e)}>
              <div className="another">+Add an author</div>
            </div>
          </div>
          <br />

          <p>
            The information you provide will be used for your copyright
            application as is. Please be sure to verify that the information is
            accurate and complete now.
          </p>
          <br />

          <EditAuthorPopup
            open={this.state.openModal}
            author={editAuthor}
            onSave={(author) => this.updateAuthor(author)}
            onClose={() => this.closeModal()}
          />
        </div>

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
  members: state.users.members,
  roles: state.global.roles,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypesCoreg,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
  loadTeamMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Authors);



// WEBPACK FOOTER //
// src/components/Copyright/Authors.jsx